import React from 'react';
import { Button, Box, Grid } from '@mui/material';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';

const LeftMenu = ({ view, setView, afterMenuChange, surveyToolsAllowed }) => {
  const handleMenuChange = menu => {
    setView(menu);
    afterMenuChange();
  };

  return (
    <Box component={Grid} item display={{ xs: 'none', sm: 'block' }}>
      <Grid item xs={12}>
        <Button
          onClick={() => handleMenuChange('chat')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 70,
            width: 70,
            marginLeft: 10,
            paddingTop: 30,
          }}
        >
          <div
            style={{
              height: 40,
              paddingLeft: 10,
              backgroundColor: view === 'chat' ? '#D2E5F5' : 'white',
              width: 65,
              paddingTop: 7,
              borderRadius: 100,
              alignContent: 'center',
              alignItems: 'center',
            }}
          >
            <QuestionAnswerIcon style={{ fontSize: 27, marginLeft: -10, color: '#41484D' }} />
          </div>

          <div>
            <p
              style={{
                paddingLeft: 0,
                marginTop: 0,
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              Chat
            </p>
          </div>
        </Button>
      </Grid>
      {surveyToolsAllowed ? (
          <Grid item xs={12}>
            <Button
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: 70,
                width: 70,
                paddingTop: 30,
                marginLeft: 10,
              }}
              onClick={() => handleMenuChange('survey')}
            >
              <div
                style={{
                  height: 40,
                  paddingLeft: 10,
                  backgroundColor: view === 'survey' ? '#D2E5F5' : 'white',
                  width: 65,
                  paddingTop: 7,
                  borderRadius: 100,
                  alignContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ListAltIcon style={{ fontSize: 27, marginLeft: -10, color: '#41484D' }} />
              </div>

              <div>
                <p
                  style={{
                    marginTop: 0,
                    fontWeight: 600,
                    fontSize: 12,
                  }}
                >
                  Survey
                </p>
              </div>
            </Button>
          </Grid>
        ) : null}
      <Grid item xs={12}>
        <Button
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 70,
            width: 70,
            paddingTop: 30,
            marginLeft: 10,
          }}
          onClick={() => handleMenuChange('settings')}
        >
          <div
            style={{
              height: 40,
              paddingLeft: 10,
              backgroundColor: view === 'settings' ? '#D2E5F5' : 'white',
              width: 65,
              paddingTop: 7,
              borderRadius: 100,
              alignContent: 'center',
              alignItems: 'center',
            }}
          >
            <SettingsIcon style={{ fontSize: 27, marginLeft: -10, color: '#41484D' }} />
          </div>

          <div>
            <p
              style={{
                marginTop: 0,
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              Settings
            </p>
          </div>
        </Button>
      </Grid>
    </Box>
  );
};

export default LeftMenu;
